// src/modules/app-views/customers/pages/Init/components/CustomersGlobalSearch/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useListContext } from 'components/core/ListProvider';

import translateX from 'utils/translateX';
import './CustomersGlobalSearch.less';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const DEBOUNCE_MS = 300;

// *******************************************************************************
// COMPONENT
// *******************************************************************************
const CustomersGlobalSearch = ({ className }) => {
  const { setTextSearch } = useListContext() || {};

  const [searchValue, setSearchValue] = useState('');
  const debounceRef = useRef(null);

  // On mount: clear any persisted textSearch in URL params (?q=).
  // Field always starts empty — stale URL filter must not remain active.
  useEffect(() => {
    setTextSearch?.('');
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = useCallback(
    e => {
      const value = e?.target?.value ?? '';
      setSearchValue(value);

      if (debounceRef.current) clearTimeout(debounceRef.current);

      if (!value.trim()) {
        setTextSearch?.('');
      } else {
        debounceRef.current = setTimeout(() => {
          setTextSearch?.(value.trim());
        }, DEBOUNCE_MS);
      }
    },
    [setTextSearch]
  );

  return (
    <Input
      className={`customers-global-search ${className ?? ''}`}
      placeholder={translateX('search_customer')}
      prefix={<SearchOutlined />}
      allowClear
      size="middle"
      value={searchValue}
      onChange={handleChange}
    />
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CustomersGlobalSearch;
